import React from 'react';

export const HeadsetIcon = ({ className, ...props }) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 60 54.46"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    className={className}
    {...props}
  >
    <path
      fill="currentColor"
      d="M49.77 39.27A19.87 19.87 0 0 1 35.33 52a3.6 3.6 0 1 1-.13-2.65c5.84-1.3 10.58-6 12.51-12.2V16.26C44.41 9 37.75 3.94 30.07 3.94S15.53 9.1 12.29 16.58v22.87a12.29 12.29 0 0 1-3.82-24C12.24 6.34 20.49 0 30.07 0S47.95 6.37 51.7 15.54a12.29 12.29 0 0 1-1.93 23.73z"
    />
  </svg>
);
